import { render, staticRenderFns } from "./ViewLocationOfArticleNumberInStockSidebar.vue?vue&type=template&id=fbd0cc88&scoped=true"
import script from "./ViewLocationOfArticleNumberInStockSidebar.vue?vue&type=script&lang=js"
export * from "./ViewLocationOfArticleNumberInStockSidebar.vue?vue&type=script&lang=js"
import style0 from "./ViewLocationOfArticleNumberInStockSidebar.vue?vue&type=style&index=0&id=fbd0cc88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbd0cc88",
  null
  
)

export default component.exports